import { z } from "zod";

export const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;
const label = z.string().min(1).max(100).regex(/^[A-Za-z0-9 _.,+-]+$/);
const click = z.string().min(1).max(256).regex(/^[A-Za-z0-9_-]+$/);
export const attributionSchema = z.object({
  utm_source: label.optional(), utm_medium: label.optional(), utm_campaign: label.optional(),
  utm_content: label.optional(), utm_term: label.optional(), fbclid: click.optional(),
  fbp: z.string().max(300).regex(/^fb\.1\.\d{13}\.\d+$/).optional(),
  fbc: z.string().max(300).regex(/^fb\.1\.\d{13}\.[A-Za-z0-9_-]+$/).optional(),
});
type ParsedAttribution = z.infer<typeof attributionSchema>;
/** Normalized transport output omits absent fields; it never writes explicit undefined. */
export type CheckoutAttribution = {
  [Key in keyof ParsedAttribution]?: Exclude<ParsedAttribution[Key], undefined>;
};

/** Validate fields independently: one malformed field must not erase the valid campaign. */
export function attributionFrom(values: Record<string, unknown>): CheckoutAttribution {
  const result: Record<string, string> = {};
  for (const key of Object.keys(attributionSchema.shape) as (keyof CheckoutAttribution)[]) {
    const parsed = attributionSchema.shape[key].safeParse(values[key]);
    if (parsed.success && parsed.data !== undefined) result[key] = parsed.data;
  }
  return result;
}

export function categoryAttribution(value: ParsedAttribution, category: "analytics" | "advertising"): CheckoutAttribution {
  return Object.fromEntries(Object.entries(value).filter(([key, field]) => Object.hasOwn(attributionSchema.shape, key) && field !== undefined && (
    category === "analytics" ? utmKeys.includes(key as typeof utmKeys[number]) : !utmKeys.includes(key as typeof utmKeys[number])
  ),
  ));
}
